// Unpublished Work © 2020-2024 Deere & Company.

import React from 'react';
import PropTypes from 'prop-types';
import {oktaAuth} from '../factories/okta-config-factory';
import {OktaCallback} from '../views/application/okta-callback';
import {Switch, Route, useHistory} from 'react-router-dom';
import {Security, SecureRoute} from '@okta/okta-react';
import {EntryComponent} from '../views/application/entry-component';
import {ConfigListenerProvider} from './config-listener-provider';
import {APP_BASE_PATH} from '../literals/customer-routes';
import {toRelativeUrl} from '@okta/okta-auth-js';
import {CustomerSearchComponent} from '../views/application/customer-search-component';

const NoAccessView = React.lazy(() => import('../views/application/no-access-view'));

export const SecurityProvider = (props) => {
    const history = useHistory();

    const restoreOriginalUri = async (_oktaAuth, originalUri) => {
        if (originalUri !== null) {
            history.replace(toRelativeUrl(originalUri, globalThis.location.origin));
        }
    };

    return (
        <Security
            oktaAuth={oktaAuth}
            restoreOriginalUri={restoreOriginalUri}
        >
            <ConfigListenerProvider>
                <Switch>
                    <SecureRoute
                        component={EntryComponent}
                        exact={true}
                        path='/'
                    />
                    <Route
                        component={OktaCallback}
                        exact={true}
                        path='/code=:code'
                    />
                    <SecureRoute
                        component={NoAccessView}
                        path='/no-access'
                    />
                    <SecureRoute
                        component={CustomerSearchComponent}
                        path={APP_BASE_PATH}
                    />
                    {props.children}
                </Switch>
            </ConfigListenerProvider>
        </Security>
    );
};

SecurityProvider.propTypes = {
    children: PropTypes.node
};
